import React from "react";
import { NavLink } from "react-router-dom";
import Form from "../common/form";
import { LoginButton } from "./common/loginButton";

export default class LoginForm extends Form {
  render() {
    const { handleSubmit, handleMFASignIn, handleDataUpdate } = this.props;

    return (
      <div className="content bg-img">
        <div className="m-3">
          <div className="row justify-content-md-center">
            <form onSubmit={handleSubmit} className="form-size col col-lg-5">
              <h1 style={{ color: "white", textAlign: "left" }}>Login</h1>
              <div style={{ color: "white", textAlign: "left" }}>
                {this.renderInput(
                  "username",
                  "Username",
                  undefined,
                  "username",
                  this.props.mfaStatus,
                  "",
                  handleDataUpdate
                )}
                {this.renderInput(
                  "password",
                  "Password",
                  "password",
                  "current-password",
                  this.props.mfaStatus,
                  "",
                  handleDataUpdate
                )}
              </div>
              {!this.props.mfaStatus && (
                <div style={{ marginTop: "24px" }}>
                  <LoginButton
                    validateForm={this.props.validateForm}
                    type={"submit"}
                  />
                  <div className="dropdown-divider"></div>
                  <NavLink
                    style={{ color: "white", textDecoration: "none" }}
                    to="forgot"
                  >
                    Forgot Password?
                  </NavLink>
                  <div
                    style={{
                      bottom: "20px",
                      left: "0",
                      right: "0",
                      position: "fixed",
                    }}
                  >
                    <div className="card">
                      <div
                        style={{
                          marginTop: "5px",
                          textShadow:
                            "0 0 1px white, 0 0 1px white, 0 0 1px white, 0 0 1px white",
                        }}
                      >
                        <strong>
                          FOR INTERNAL USE ONLY. NOT FOR USE WITH THE PUBLIC.
                        </strong>
                      </div>
                      <div
                        style={{
                          marginTop: "5px",
                          textShadow:
                            "0 0 1px white, 0 0 1px white, 0 0 1px white, 0 0 1px white",
                        }}
                      >
                        <strong>
                          Advisory Services offered through Vicus Capital, Inc.,
                          a federally Registered Investment Advisor.
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {this.props.mfaStatus && (
                <div style={{ color: "white", textAlign: "left" }}>
                  {this.renderInput(
                    "mfaCode",
                    "Multi Factor Authentication Code",
                    "Text",
                    "off",
                    false,
                    "",
                    handleDataUpdate
                  )}
                  <div style={{ marginTop: "20px" }}>
                    <LoginButton
                      onClick={handleMFASignIn}
                      validateForm={this.props.validateMFAForm}
                      disabled={!this.props.validateMFAForm()}
                    />
                  </div>
                  <div className="dropdown-divider"></div>
                  <p>Unable to login?</p>
                  <p>
                    Contact Support:
                    <br />
                    (855) 558-4287
                  </p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
